import firebase from "firebase/compat/app"
import "firebase/compat/auth"

const app = firebase.initializeApp({
    // apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    // authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    // projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    // storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    // messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    // appId: process.env.REACT_APP_FIREBASE_APP_ID 
    apiKey: "AIzaSyAX0FWbP7-EaK40Del2L_NkMZmyfuF7VGU",
    authDomain: "childrendocdev.firebaseapp.com",
    projectId: "childrendocdev",
    storageBucket: "childrendocdev.appspot.com",
    messagingSenderId: "719399037789",
    appId: "1:719399037789:web:c86e5510bd0182a8ff96b4"
})

export const auth = app.auth()
export default app
